// extracted by mini-css-extract-plugin
export default {"nav":"BaseNavBar_nav__njuPq"};